import { gql } from '@apollo/client';
export const GRAPHQL_ATUALIZAR_DOCUMENTO: any = gql`
    mutation atualizarDocumento(
        $entregadorId: ID!
        $data: EntregadorDocumentoAtualizarInput!
    ) {
        atualizarDocumento(entregadorId: $entregadorId, data: $data)
    }
`;
